export default __webpack_public_path__ + "static/media/185.602bff06.png";